/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { HeadingLineDialogComponent } from './components/heading-line-dialog/heading-line-dialog.component';
import { HeadingListComponent } from './components/heading-list/heading-list.component';
import { HeadingListBusinessService } from './resources/heading-list-business.service';
import { BuilderSetupRfqStructureRoutingModule } from './rfq-structure-routing.module';

@NgModule({
  imports: [
    DragDropModule,
    BuilderSharedModule.forChild(),
    BuilderSetupRfqStructureRoutingModule,
  ],
  providers: [
    HeadingListBusinessService,
  ],
  declarations: [
    HeadingListComponent,
    HeadingLineDialogComponent,
  ],
})
export class BuilderSetupRfqStructureModule {
}
